export default {
  methods : {
    apolloQueryManually(queryOptions){
      return new Promise((resolve) => {
        this.$apollo.query(queryOptions).then(
          result => {
            resolve({
              success     : true,
              reslut      : result,

              firstError  : null,
              errorSet    : [],
              error       : null,
            });
          },
          err    => {
            const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);

            resolve(simpleErrorSet);
          }
        );
      });
    },

    getApolloRequestErrorSet(err){
      let firstError  = null;
      const errorList = this.getApolloErrorSetList(err);

      if(errorList.length >= 1){
        firstError = errorList[0];
      }

      return {
        first : firstError,
        list  : errorList,
      }
    },

    getApolloSimpleErrorSet(errorSet, err){
      return {
        success     : false,
        result      : null,

        firstError  : errorSet.first,
        errorSet    : errorSet.list,
        error       : err,
      };
    },

    getApolloSimpleErrorFromApolloError(err){
      return this.getApolloSimpleErrorSet(
        this.getApolloRequestErrorSet(err),
        err
      );
    },

    getApolloErrorSetList(err){
      const errorSet = [];

      if(typeof err !== 'object') return errorSet;
      if(typeof err.graphQLErrors !== 'object') return errorSet;

      if(err.graphQLErrors.length === 0){
        errorSet.push({
          category  : 'maintenance',
          field     : null,
          message   : null,
          data      : null,
        });
        
        return errorSet;
      }

      for(let i = 0; i < err.graphQLErrors.length; i++){
        const singleSet = {
          category  : null,
          field     : null,
          message   : null,
          data      : null,
        };

        if(typeof err.graphQLErrors[i].extensions.category !== 'undefined'){
          singleSet.category = err.graphQLErrors[i].extensions.category;
        }

        if(singleSet.category === 'validation'){
          const validationError = this.getApolloResultFirstValidationError(err.graphQLErrors[i]);
          
          singleSet.field   = validationError.firstField;
          singleSet.message = validationError.firstMessage;
          singleSet.data    = validationError.data;
        }

        if(singleSet.message === null){
          if(typeof err.graphQLErrors[i].message !== 'undefined'){
            singleSet.message  = err.graphQLErrors[i].message;
          }
        }

        errorSet.push(singleSet);
      }

      return errorSet;
    },

    getApolloResultFirstValidationError(errorSet){
      const validationError = {
        firstField    : null,
        firstMessage  : null,
        data          : null
      };

      if(typeof errorSet.extensions.validation !== 'undefined'){
        validationError.data = errorSet.extensions.validation;

        let validationCount = 0;
        for(let fieldName in errorSet.extensions.validation){
          if(validationCount > 0) break;
          
          validationError.firstField = fieldName;

          if(typeof errorSet.extensions.validation[fieldName][0] !== 'undefined'){
            validationError.firstMessage = errorSet.extensions.validation[fieldName][0];
          }else{
            validationError.firstMessage = errorSet.extensions.validation[fieldName];
          }

          validationCount++;
        }
      }

      return validationError;
    },

    async apolloResultValidation(result){
      if(result.firstError === null) return true;

      switch(result.firstError.category){
        case 'authentication':
          await this.handleRequestValidationError('authentication');
        break;

        case 'emailUnCertificated':
          await this.handleRequestValidationError('emailUnCertificated');
        break;

        case 'maintenance':
          await this.handleRequestValidationError('ServiceUnavailable');
        break;

        default:
          await this.handleRequestValidationError('default');
        break;
      }

      return false;
    }
  }
}